export default "__VITE_ASSET__Ce5$yit3__"